export const menuListOptions = {
	OMNI: [
		{
			id: 'netSales',
			label: 'Net Sales',
			type: 'currency', // currency | unit | percent
			metricType: 'sales',
			metrics: ['netSalesLY', 'netSalesTY', 'netSalesYoY', 'netSalesYoYPctChg'],
		},
		{
			id: 'units',
			label: 'Units',
			type: 'unit',
			metricType: 'sales',
			metrics: ['unitsLY', 'unitsTY', 'unitsYoY', 'unitsYoYPctChg'],
		},
		{
			id: 'aur',
			label: 'AUR',
			type: 'currency',
			metricType: 'sales',
			metrics: ['aurLY', 'aurTY', 'aurYoY', 'aurYoYPctChg'],
		},
		{
			id: 'netSalesYoYPctChg',
			label: 'Net Sales YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['netSalesYoYPctChg'],
		},
		{
			id: 'unitsYoYPctChg',
			label: 'Units YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['unitsYoYPctChg'],
		},
		{
			id: 'aurYoYPctChg',
			label: 'AUR YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['aurYoYPctChg'],
		},
	],
	ECOM: [
		{
			id: 'netSales',
			label: 'Net Sales',
			type: 'currency', // currency | unit | percent
			metricType: 'sales',
			metrics: ['netSalesLY', 'netSalesTY', 'netSalesYoY', 'netSalesYoYPctChg'],
		},
		{
			id: 'units',
			label: 'Units',
			type: 'unit',
			metricType: 'sales',
			metrics: ['unitsLY', 'unitsTY', 'unitsYoY', 'unitsYoYPctChg'],
		},
		{
			id: 'aur',
			label: 'AUR',
			type: 'currency',
			metricType: 'sales',
			metrics: ['aurLY', 'aurTY', 'aurYoY', 'aurYoYPctChg'],
		},
		{
			id: 'netSalesYoYPctChg',
			label: 'Net Sales YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['netSalesYoYPctChg'],
		},
		{
			id: 'unitsYoYPctChg',
			label: 'Units YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['unitsYoYPctChg'],
		},
		{
			id: 'aurYoYPctChg',
			label: 'AUR YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['aurYoYPctChg'],
		},
	],
	STORE: [
		{
			id: 'netSales',
			label: 'Net Sales',
			type: 'currency', // currency | unit | percent
			metricType: 'sales',
			metrics: ['netSalesLY', 'netSalesTY', 'netSalesYoY', 'netSalesYoYPctChg'],
		},
		{
			id: 'units',
			label: 'Units',
			type: 'unit',
			metricType: 'sales',
			metrics: ['unitsLY', 'unitsTY', 'unitsYoY', 'unitsYoYPctChg'],
		},
		{
			id: 'aur',
			label: 'AUR',
			type: 'currency',
			metricType: 'sales',
			metrics: ['aurLY', 'aurTY', 'aurYoY', 'aurYoYPctChg'],
		},
		{
			id: 'netSalesYoYPctChg',
			label: 'Net Sales YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['netSalesYoYPctChg'],
		},
		{
			id: 'unitsYoYPctChg',
			label: 'Units YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['unitsYoYPctChg'],
		},
		{
			id: 'aurYoYPctChg',
			label: 'AUR YoY % Change',
			type: 'percent',
			metricType: 'sales',
			metrics: ['aurYoYPctChg'],
		},
		{
			id: 'storeOnHandQty',
			label: 'Store On Hand Quantity',
			type: 'unit',
			metricType: 'inventory',
			metrics: [
				'storeOnHandQtyLY',
				'storeOnHandQtyTY',
				'storeOnHandQtyYoY',
				'storeOnHandQtyYoYPctChg',
			],
		},
		{
			id: 'storeOnOrderQty',
			label: 'Store On Order Quantity',
			type: 'unit',
			metricType: 'inventory',
			metrics: [
				'storeOnOrderQtyLY',
				'storeOnOrderQtyTY',
				'storeOnOrderQtyYoY',
				'storeOnOrderQtyYoYPctChg',
			],
		},
		{
			id: 'storeInTransitQty',
			label: 'Store In Transit Quantity',
			type: 'unit',
			metricType: 'inventory',
			metrics: [
				'storeInTransitQtyLY',
				'storeInTransitQtyTY',
				'storeInTransitQtyYoY',
				'storeInTransitQtyYoYPctChg',
			],
		},
		{
			id: 'storeInWarehouseQty',
			label: 'Store In Warehouse Quantity',
			type: 'unit',
			metricType: 'inventory',
			metrics: [
				'storeInWarehouseQtyLY',
				'storeInWarehouseQtyTY',
				'storeInWarehouseQtyYoY',
				'storeInWarehouseQtyYoYPctChg',
			],
		},

		{
			id: 'totalStoreInventory',
			label: 'Total Store Inventory',
			type: 'unit',
			metricType: 'inventory',
			metrics: [
				'totalStoreInventoryLY',
				'totalStoreInventoryTY',
				'totalStoreInventoryYoY',
				'totalStoreInventoryYoYPctChg',
			],
		},
		{
			id: 'storeOnHandQtyYoYPctChg',
			label: 'Store On Hand Quantity YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['storeOnHandQtyYoYPctChg'],
		},
		{
			id: 'storeOnOrderQtyYoYPctChg',
			label: 'Store On Order Quantity YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['storeOnOrderQtyYoYPctChg'],
		},
		{
			id: 'storeInTransitQtyYoYPctChg',
			label: 'Store In Transit Quantity YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['storeInTransitQtyYoYPctChg'],
		},

		{
			id: 'storeInWarehouseQtyYoYPctChg',
			label: 'Store In Warehouse Quantity YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['storeInWarehouseQtyYoYPctChg'],
		},

		{
			id: 'totalStoreInventoryYoYPctChg',
			label: 'Total Store Inventory YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['totalStoreInventoryYoYPctChg'],
		},

		{
			id: 'inStockPct',
			label: 'Instock %',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['inStockPctLY', 'inStockPctTY', 'inStockYoYPctChg'],
		},
		{
			id: 'inStockYoYPctChg',
			label: 'Instock % YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['inStockYoYPctChg'],
		},

		{
			id: 'dollarStoreWk',
			label: 'Dollar/Store/Week',
			type: 'currency',
			metricType: 'inventory',
			metrics: [
				'dollarStoreWkLY',
				'dollarStoreWkTY',
				'dollarStoreWkYoY',
				'dollarStoreWkYoYPctChg',
			],
		},
		{
			id: 'qtyStoreWk',
			label: 'Units/Store/Week',
			type: 'unit',
			metricType: 'inventory',
			metrics: [
				'qtyStoreWkLY',
				'qtyStoreWkTY',
				'qtyStoreWkYoY',
				'qtyStoreWkYoYPctChg',
			],
		},
		{
			id: 'dollarStoreWkYoYPctChg',
			label: 'Dollar/Store/Week YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['dollarStoreWkYoYPctChg'],
		},
		{
			id: 'qtyStoreWkYoYPctChg',
			label: 'Units/Store/Week YoY % Change',
			type: 'percent',
			metricType: 'inventory',
			metrics: ['qtyStoreWkYoYPctChg'],
		},
		{
			id: 'ftprRate',
			label: 'FTPR Rate',
			type: 'percent',
			metricType: 'opd',
			metrics: ['ftprRate'],
		},
		{
			id: 'preSubRate',
			label: 'Pre Sub Rate',
			type: 'percent',
			metricType: 'opd',
			metrics: ['preSubRate'],
		},
		{
			id: 'postSubRate',
			label: 'Post Sub Rate',
			type: 'percent',
			metricType: 'opd',
			metrics: ['postSubRate'],
		},
		{
			id: 'nilPikRate',
			label: 'Nil Pick Rate',
			type: 'percent',
			metricType: 'opd',
			metrics: ['nilPikRate'],
		},
		{
			id: 'preSubQty',
			label: 'Pre Sub Quantity',
			type: 'unit',
			metricType: 'opd',
			metrics: ['preSubQty'],
		},
		{
			id: 'nilPickQty',
			label: 'Nil Pick Quantity',
			type: 'unit',
			metricType: 'opd',
			metrics: ['nilPickQty'],
		},
		{
			id: 'totalOrderQty',
			label: 'Total Order Quantity',
			type: 'unit',
			metricType: 'opd',
			metrics: ['totalOrderQty'],
		},
	],
};

export const timePeriodOptions = ['Daily', 'Weekly', 'Monthly'];

export const granularityPeriod = {
	Daily: 'DAY',
	Weekly: 'WEEK',
	Monthly: 'MONTH',
};

export const sales = [
	'aurLY',
	'aurTY',
	'aurYoY',
	'aurYoYPctChg',
	'netSalesLY',
	'netSalesTY',
	'netSalesYoY',
	'netSalesYoYPctChg',
	'unitsLY',
	'unitsTY',
	'unitsYoY',
	'unitsYoYPctChg',
];

export const inventory = [
	'dollarStoreWkLY',
	'dollarStoreWkTY',
	'dollarStoreWkYoY',
	'dollarStoreWkYoYPctChg',
	'inStockPctLY',
	'inStockPctTY',
	'inStockYoYPctChg',
	'qtyStoreWkLY',
	'qtyStoreWkTY',
	'qtyStoreWkYoY',
	'qtyStoreWkYoYPctChg',
	'storeInTransitQtyLY',
	'storeInTransitQtyTY',
	'storeInTransitQtyYoY',
	'storeInTransitQtyYoYPctChg',
	'storeInWarehouseQtyLY',
	'storeInWarehouseQtyTY',
	'storeInWarehouseQtyYoY',
	'storeInWarehouseQtyYoYPctChg',
	'storeOnHandQtyLY',
	'storeOnHandQtyTY',
	'storeOnHandQtyYoY',
	'storeOnHandQtyYoYPctChg',
	'storeOnOrderQtyLY',
	'storeOnOrderQtyTY',
	'storeOnOrderQtyYoY',
	'storeOnOrderQtyYoYPctChg',
	'totalStoreInventoryLY',
	'totalStoreInventoryTY',
	'totalStoreInventoryYoY',
	'totalStoreInventoryYoYPctChg',
];

export const opd = [
	'ftprRate',
	'nilPickQty',
	'nilPikRate',
	'postSubRate',
	'preSubQty',
	'preSubRate',
	'subQty', // which metric is this?
	'totalOrderQty',
];
